import React from 'react';
import Slider from 'react-slick';
import { useSanityData } from '../hooks/useSanityData';
import { urlFor } from '../sanityClient';

function NextArrow({ onClick }) {
  return (
    <button type='button' className='slick-next pull-right slick-arrow d-block' onClick={onClick}>
      <img src='images/next-arrow.svg' className='img-fluid' alt='arrow' />
    </button>
  );
}
function PrevArrow({ onClick }) {
  return (
    <button type='button' className='slick-prev pull-left slick-arrow d-block' onClick={onClick}>
      <img src='images/prev-arrow.svg' className='img-fluid' alt='arrow' />
    </button>
  );
}

// Fetches all platform courses from Sanity and renders the Platform-style carousel.
export default function PlatformCards({ heading, description, slidesToShow = 4, autoplaySpeed = 2500 }) {
  const lang = localStorage.getItem('language') || 'arm';

  const query = `*[_type == "platformCourse"] | order(navOrder asc, year asc) {
    _id, title, slug, year, poster
  }`;
  const { data: courses, loading } = useSanityData(query);

  const slickerSettings = {
    infinite: true,
    centerPadding: '10px',
    slidesToShow,
    slidesToScroll: 1,
    speed: 500,
    centerMode: true,
    variableWidth: false,
    centerMargin: '0',
    className: 'bem',
    autoplay: true,
    arrow: false,
    dots: true,
    autoplaySpeed,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerPadding: '0',
          slidesToShow: 1,
          slidesToScroll: 0,
          adaptiveHeight: false,
          dots: true,
          prevArrow: <PrevArrow />,
          nextArrow: <NextArrow />,
        },
      },
    ],
  };

  if (loading || !courses) return null;

  const headingStr     = heading     ? (heading[lang]     || heading.en     || '') : '';
  const descriptionStr = description ? (description[lang] || description.en || '') : '';

  return (
    <section className='main-container main-container-decoration platform-container we-play-container'>
      <div className='description-banner'>
        {headingStr && <h2 className='title-generic'>{headingStr}</h2>}
        {descriptionStr && <p dangerouslySetInnerHTML={{ __html: descriptionStr }} />}
      </div>
      <section className='center-slider the-platform-slider'>
        <Slider {...slickerSettings}>
          {courses.map((c) => {
            const title  = c.title ? (c.title[lang] || c.title.en || '') : '';
            const slug   = c.slug?.current || c.slug || '';
            const imgSrc = c.poster ? urlFor(c.poster).width(400).url() : '';
            return (
              <div className='slide' key={c._id}>
                <div className='slider-title'>
                  <h2>{title}</h2>
                  <h2>{c.year}</h2>
                </div>
                <div className='child-element'>
                  <div className='deco1 animate animate__animated animate__bounce animate__delay-0 animate__fadeInDown'>
                    <img src='images/decoration1.svg' alt='icon' className='img-fluid' />
                  </div>
                  <a href={`/platform/${slug}`}>
                    <img src={imgSrc} alt={title} className='img-fluid' />
                  </a>
                  <div className='deco2 animate animate__animated animate__bounce animate__delay-0 animate__fadeInDown'>
                    <img src='images/decoration2.svg' alt='icon' className='img-fluid' />
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </section>
    </section>
  );
}
